<template>
  <div>
    <title>ERP发货记录</title>
     <section class="orderSect">
      <!--S 检索-->      
      <el-form :inline="true" :model="printFormInline">
        <el-form-item label="订单号" class="codeSerIpt">
          <el-input v-model="printFormInline.orderno" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="printFormInline.phone" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人">
          <el-input  v-model="printFormInline.Name" placeholder="请输入收货人" clearable></el-input>
        </el-form-item> 
        <el-form-item>
          <el-button type="primary" @click="getErpExps">查询</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->

      <!--S 快递打印列表-->
      <div class="allOrderTab individualiz">
        <el-form :model="printFormInline" inline size="medium">
          <el-form-item class="borderline">
            <em class="greyColor">{{screenStatusTit}}订单</em>
            <el-checkbox-group v-model="printFormInline.screenStatus" @change="changeStatus">
              <el-checkbox v-for="(item,index) of ScreenStatusLists" :label="item.value" :key="index">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="borderline borderNone">
            <em class="greyColor">发货状态</em>
            <el-checkbox-group v-model="printFormInline.deyStatus" @change="changeStatus">
              <el-checkbox v-for="(item,index) of DeliveryStatusLists" :label="item.value" :key="index">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>  
          <el-form-item>
            <el-button v-popover:erpOrderPop v-if="ERPType != 4" @click="orderNowByMemu()">立即下单</el-button>
            <el-popover placement="top" width="190" trigger="hover" ref="erpOrderPop">
              <p class="greyColor">直接调用{{screenStatusTit}}下单接口，请耐心等待！</p>
            </el-popover>
          </el-form-item>                       
        </el-form>
        <el-table v-loading="loading" :data="printRecordData" ref="expressTable" class="orderTable comTable" border :maxHeight="tableHeight" >     
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="快递内容" prop="expcontent" sortable min-width="250">
              <template slot-scope="scope">
                <small>订单号：{{scope.row.orderno}}</small>
                <p class="textFl" :title="scope.row.expcontent">{{scope.row.expcontent}}</p>
              </template>
            </el-table-column>
            <el-table-column label="收货信息" prop="fulladdr" sortable min-width="350" >
              <template slot-scope="scope">
                <div class="shouMsg">
                  <em v-if="scope.row.receivername">{{scope.row.receivername}}</em>
                  <em v-if="scope.row.receivertel">{{scope.row.receivertel}}</em>
                </div>              
                <p v-if="scope.row.fulladdr" class="greyColor textFl" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" sortable prop="expgendate" min-width="180">
              <template slot-scope="scope">{{dateTime(scope.row.expgendate, 1)}}</template>
            </el-table-column>
            <el-table-column label="下单状态" prop="screenstate" sortable min-width="250">
              <template slot-scope="scope">
                <p :class="scope.row.screenstate | screenStateColorFilter">{{scope.row.screenstate | screenStateFilter}}</p>
                <p v-if="ERPType == 2" class="greyColor textFl">
                  <em v-if="scope.row.erporderno">管易单号：{{scope.row.erporderno}}</em>
                  <span>{{scope.row.returnmsg}}</span>
                </p>
                <p v-if="ERPType == 4" class="greyColor textFl">
                  <em v-if="scope.row.expno">出库单号：{{scope.row.expno}}</em>
                  <span>{{scope.row.returnmsg}}</span>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="发货状态" prop="deliverstate" sortable min-width="120">
              <template slot-scope="scope">
                <span :class="[{'blueColor':scope.row.deliverstate==1 || scope.row.deliverstate==3},{'orangeColor':scope.row.deliverstate==0},{'redColor':scope.row.deliverstate==2 || scope.row.deliverstate==6},{'greyColor':scope.row.deliverstate==4},{'greenColor':scope.row.deliverstate==5}]">{{scope.row.deliverstate | deliverStateFilter}}</span>
              </template>
            </el-table-column>
            <el-table-column label="发货时间" prop="deliverdate" sortable min-width="180">
              <template slot-scope="scope">
                <span>{{dateTime(scope.row.deliverdate, 1)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <p class="handle">
                  <span title="详情" @click="viewDetail(scope.row.expcode)"><i class="icondetails"></i></span>
                </p>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="noData"><span>暂无数据</span></div>
            </template>
        </el-table>
      </div>
      <!--S 快递打印列表-->
      <Page :pageTotal="pagebean.totalnum" :currentPage="pagebean.currentpage" @nowPageParam="setPageparam"></Page>
    </section>

    <!--S 快递详情组件-->
    <DeliveryDetail :deliveryDetailBox="expressDetailShow" :expcode="expcode" @closeDDBox="expressDetailShow = false"></DeliveryDetail>
    <!--E 快递详情组件-->
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import api from '../../apis/api';
export default {
  name: 'PrintRecordBatchDetail',
  data () {
    return {
      ERPType:0,//ERP类型
      screenStatusTit:'旺店通',//ERP筛单状态名
      DeliveryStatusLists: [ 
        { label: "待发货", value: "0" },
        { label: "已发货", value: "1" },
        { label: "退货", value: "2" },
        { label: "已补发", value: "3" },
        { label: "无效快递", value: "4" },
        { label: "已签收", value: "5" },
        { label: "异常签收", value: "6" },
      ], //发货状态
      ScreenStatusLists: [ 
        { label: "待筛单", value: "0" },
        { label: "筛单成功", value: "1" },
        { label: "筛单失败", value: "2" },
        { label: "筛单异常", value: "4" },
      ],//筛单状态
      printFormInline:{
        orderno: "", //订单号
        phone:"",//手机号
        Name:"",//收货人
        deyStatus:[],//发货状态
        screenStatus:[],//筛单状态
      },
      printRecordData:[],//打印列表数据
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      expressDetailShow:false, //快递详情
      pagebean: {
        pagesize: 30,
        currentpage: 1
      },//分页
      loading: true,//加载
      expcode: '',//快递编号
      subNow: 0,//是否立即下单
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    DeliveryDetail: resolve => require(["@/components/common/DeliveryDetail.vue"], resolve), //快递详情组件
  },
  watch: {
    'ERPType'(val) {
      //清空检索条件
      this.printFormInline = {
        orderno: "", //订单号
        phone:"",//手机号
        Name:"",//收货人
        deyStatus:[],//发货状态
        screenStatus:[],//筛单状态
      }
      this.getErpExps()
    },
    $route() {
      this.ERPType = Number(this.$route.query.type);
      //console.log(this.ERPType,'erp类型');
      if(this.ERPType==0){
        this.screenStatusTit = '旺店通';
      }else if(this.ERPType==1){
        this.screenStatusTit = 'E店宝';
      }else if(this.ERPType==2){
        this.screenStatusTit = '管易';
      }else if(this.ERPType==3){
        this.screenStatusTit = '网店管家';
      }else if(this.ERPType==4){
        this.screenStatusTit = '京东云仓';
      }
    },
  },
  methods: {
    orderNowByMemu() {
      MessageBox.confirm('确定要立即下单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.orderNow()
      }).catch(() => {
      });
    },
    //立即下单
    orderNow(){
      this.loading = true
      let params = {
        screenstate: this.printFormInline.screenStatus,
        deliverstate: this.printFormInline.deyStatus,
        handletype: this.ERPType==0 ? 1006 : this.ERPType==1 ? 1005 : this.ERPType==2 ? 1004 : this.ERPType==3 ? 1007 : 107,
        orderno: this.printFormInline.orderno, //订单号
        name: this.printFormInline.Name,
        mobileNumber: this.printFormInline.phone,
      }
      api.SUBGYORDER(params).then(res => {
        if(res.data.status == '200') {
          Message({
            type: 'success',
            message: res.data.message
          });
        } else {
          Message({
            type: 'error',
            message: res.data.message
          });
        }
        this.loading = false
      })
      this.sendOrder = false;
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.expressTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
    },

    //设置分页数据
    setPageparam(nowPageSize, nowCurrentPage) {
      if(nowPageSize) {
        this.pagebean.pagesize = nowPageSize
      }
      if(nowCurrentPage) {
        this.pagebean.currentpage = nowCurrentPage
      }
      this.getErpExps()
    },

    //查看详情
    viewDetail(expcode) {
      this.expressDetailShow = true
      this.expcode = expcode
    },

    //更改检索条件
    changeStatus() {
      this.getErpExps()
    },

    //查询漏单列表
    getErpExps() {
      this.loading = true
      let params = {
        handletype: this.ERPType==0 ? 1006 : this.ERPType==1 ? 1005 : this.ERPType==2 ? 1004 : this.ERPType==3 ? 1007 : 107,
        orderno: this.printFormInline.orderno, //订单号
        name: this.printFormInline.Name,
        mobileNumber: this.printFormInline.phone,
        screenstate: this.printFormInline.screenStatus,
        deliverstate: this.printFormInline.deyStatus,
        pageparam: this.pagebean
      }
      api.GET_ERPFINDEXPLIST(params).then(res => {
        if(res.data.status == '200') {
          this.printRecordData = res.data.data
          this.pagebean = res.data.pagebean
        } else {
          this.printRecordData = []
        }
        this.loading = false
      })
    },

  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    if (this.$route.query.type) {
      this.ERPType = Number(this.$route.query.type);
    }
    if (this.$route.query.subNow) {
      this.subNow = Number(this.$route.query.subNow)
    }
    //在dom渲染之后
    setTimeout(() => {
      this.getHeight()
      this.getErpExps()
      if(this.subNow == 1) {
        this.orderNow()
      }
    }, 200);
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
@import "Css/Style.css";
</style>



// WEBPACK FOOTER //
// src/views/DeliveryFolder/ERPDeliveryRecord.vue